import React, { useEffect, useMemo, useState } from 'react';
import { Table, Button, Modal } from 'react-bootstrap';
import { FaTimes, FaEdit, FaCheck, FaLink } from 'react-icons/fa';
import FormReceiveAddress from './FormReceiveAddress';
import { GET_MANY_USER_ADDRESS_USER_ID } from '../../../../graphql/userConfirm/userAddress/query';
import { useLazyQuery } from '@apollo/client';
import _ from 'lodash';
import './ListReceiveAddress.css';
import DeleteReceiveAddress from './DeleteReceiveAddress';
import { GET_SETTING_BY_SHOP } from '../../../../graphql/setting/query';
import { HAL_KEY, MIXAY_KEY } from '../../../../constants';
import { GET_MIXAY_DEFAULT_DSE } from '../../../../graphql/shop/shopAddress/query';
// import UpdateReceiveAddress from './UpdateReceiveAddress';

const ListReceiveAddress = ({ userId, idSelect, setIdSelect, userConfirm, psid, onClose, setIsDataSelect, setIsSelect, orderGroup }) => {
    // useState
    const [editData, setEditData] = useState({});

    // GET USER
    const [userAddressUserId_API, { data: userAddressUserId_DATA, loading: userAddressUserIdLoading }] = useLazyQuery(GET_MANY_USER_ADDRESS_USER_ID, { fetchPolicy: "cache-and-network" });
    const [getMixayDefaultDSE_API, { data: getMixayDefaultDSE_DATA }] = useLazyQuery(GET_MIXAY_DEFAULT_DSE, { fetchPolicy: "cache-first" });
    const [settingByShopId_API, { data: settingByShopId_DATA }] = useLazyQuery(GET_SETTING_BY_SHOP, { fetchPolicy: "cache-first" });
    useEffect(() => {
        if (userId) {
            fetchUserAddressUserId_API();
            fetchSettingByShopId_API();
            getMixayDefaultDSE_API({
                variables: {
                    where: {
                        shop: orderGroup?.shop?.id
                    },
                },
            });
        }
    }, [userId]);

    const isMixayDefaultDSE = useMemo(() => {
        if (getMixayDefaultDSE_DATA) {
            const response = JSON.parse(getMixayDefaultDSE_DATA?.getMixayDefaultDSE);
            return response?.data?.dropship_end;
        }
    }, [getMixayDefaultDSE_DATA]);

    const fetchSettingByShopId_API = async () => {
        try {
            // get shop in local storage
            const shopId = orderGroup?.shop?.id;
            await settingByShopId_API({
                variables: {
                    where: {
                        shop: shopId
                    },
                },
            });
        } catch (err) {
            console.log("ERROR_fetchSettingByShopId_API")
        }
    };

    const [isReceive, setIsReceive] = useState([]);
    useEffect(() => {
        if (userAddressUserId_DATA) {
            console.log("userAddressUserId_DATA?.userAddressUserId?.data", userAddressUserId_DATA?.userAddressUserId?.data);
            const newIsReceive = userAddressUserId_DATA?.userAddressUserId?.data.map((item) => {
                return { ...item, isSelected: idSelect === item?.id ? true : false }
            });
            setIsReceive(newIsReceive);
        }
    }, [userAddressUserId_DATA]);


    // * ADD USER-RECEIVE ADDRESS
    const [isAddModal, setIsAddModal] = useState(false);
    const onCloseModalAdd = () => {
        setIsAddModal(false);
        setEditData({});
    };

    // * DELETE USER-RECEIVE ADDRESS
    const [isDeleteReceiveModal, setIsDeleteReceiveModal] = useState(false);
    const [isDeleteReceiveData, setIsDeleteReceiveData] = useState({});
    const onCloseDeleteReceiveModal = () => {
        setIsDeleteReceiveModal(false);
        fetchUserAddressUserId_API();
    };

    // * UPDATE USER-RECEIVE ADDRESS
    // const [isUpdateReceiveModal, setIsUpdateReceiveModal] = useState(false);
    // const [isUpdateReceiveData, setIsUpdateReceiveData] = useState({});
    // const onCloseUpdateReceiveModal = () => {
    //     setIsUpdateReceiveModal(false);
    //     fetchUserAddressUserId_API();
    // };
    // const handleSelectDefault = (id) => {
    //     setIsReceive(isReceive.map(receive => ({ ...receive, default: receive?.id === id })));
    // };
    // const handleEdit = ({value}) => {
    //     setIsUpdateReceiveData({value});
    //     setIsUpdateReceiveModal(true);
    // };

    const fetchUserAddressUserId_API = async () => {
        try {
            if(userAddressUserIdLoading) return;
            console.log("fetchUserAddressUserId_API", userId);
            await userAddressUserId_API({
                variables: {
                    where: {
                        user: userId
                    },
                },
            });
        } catch (err) {
            console.log("ERROR_fetchUserAddressUserId_API", err)
        }
    }

    const handleSelect = ({ value, id }) => {
        if (value?.deliveryName === "OF_POINT") {
            const newSetting = settingByShopId_DATA?.settingByShopId;
            const sender = {
                fullName: newSetting?.shop?.name,
                tel: newSetting?.shop?.phone,
                province: newSetting?.shop?.address?.province,
                district: newSetting?.shop?.address?.district,
                village: newSetting?.shop?.address?.village,
                branch: newSetting?.shop?.address?.village
            }
            setIsReceive(isReceive.map(receive => ({ ...receive, isSelected: receive?.id === id })));
            setIsDataSelect({ ...value, sender, latLong: newSetting?.latLong });
        } else {
            setIsReceive(isReceive.map(receive => ({ ...receive, isSelected: receive?.id === id })));
            setIsDataSelect(value);
        }
        setIdSelect(id);
        setIsSelect(true);
    };

    const handleDelete = ({ value }) => {
        setIsDeleteReceiveData({ value });
        setIsDeleteReceiveModal(true);
    };

    //TODO MIXAY...
    const handleEdit = ({ value }) => {
        console.log("edit data", value);
        setEditData(value);
        setIsAddModal(true);
    };

    const newAddress = (value) => {
        return value?.deliveryName === MIXAY_KEY
            ? `${value?.branchCode}-${value?.village}-${value?.district}-${value?.province}`
            : value?.address || "Address not found...";
    }
    const handleDisableRow = (key, data) => {
        switch (key) {
            case MIXAY_KEY:
                return data?.mxIsOpen ? false : true;
            case "OF_POINT":
                return data?.deliveryOfPoint ? false : true;
            case HAL_KEY:
                return data?.halIsOpen ? false : true;
            default:
                return false;
        }
    }

    if (_.isEmpty(isReceive)) return (<><h5>Is loading...</h5></>)

    return (
        <div>
           
            <Table bordered className="table-responsive">
                <tbody>
                    {_.isEmpty(isReceive) ? null : isReceive.map((receive) => (
                        <>
                            {receive?.deliveryName === "OF_POINT" ? (
                                <>
                                    {settingByShopId_DATA?.settingByShopId?.deliveryOfPoint ? (
                                        <tr key={receive?.id}
                                            className={ ((!isMixayDefaultDSE && receive?.deliveryName === MIXAY_KEY )) 
                                                || (( handleDisableRow(receive?.deliveryName, settingByShopId_DATA?.settingByShopId))) ? 'disabled-row' : ''}
                                        >
                                            <td style={{ width: '5%', textAlign: 'center', verticalAlign: 'middle' }}>
                                                <div className="custom-checkbox-wrapper">
                                                    <input
                                                        type="checkbox"
                                                        id={`checkbox-${receive?.id}`}
                                                        checked={receive?.isSelected}
                                                        onChange={() => handleSelect({ value: receive, id: receive?.id })}
                                                        className="custom-checkbox"
                                                    />
                                                    <label htmlFor={`checkbox-${receive?.id}`} className="custom-checkbox-label">
                                                        {receive?.isSelected && <FaCheck className="check-icon" />} {/* Show icon if selected */}
                                                    </label>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div>
                                                        <p className="fw-bold mb-1" style={{ fontSize: '0.95rem' }}>
                                                            ຮັບເຄື່ອງຫນ້າຮ້ານ: ({settingByShopId_DATA?.settingByShopId?.shop?.name}-{settingByShopId_DATA?.settingByShopId?.shop?.phone})
                                                        </p>
                                                        <small className="text-muted">ຂໍ້ມູນສ່ວນໂຕ:{receive?.userName}-{receive?.userTel}</small>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '10%', textAlign: 'center', verticalAlign: 'middle' }}>
                                                <a href={settingByShopId_DATA?.settingByShopId?.latLong} target="google_map" className="btn btn-sm btn-primary">
                                                    {/* <FaLink className="me-2" /> */}
                                                    ແຜ່ນທີ່
                                                </a>
                                            </td>
                                        </tr>
                                    ) : null}
                                </>
                            )
                                : (
                                    <tr 
                                        key={receive?.id}
                                        className={ ((!isMixayDefaultDSE && receive?.deliveryName === MIXAY_KEY )) 
                                            || (( handleDisableRow(receive?.deliveryName, settingByShopId_DATA?.settingByShopId))) ? 'disabled-row' : ''}
                                    >
                                        <td style={{ width: '5%', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <div className="custom-checkbox-wrapper">
                                                <input
                                                    type="checkbox"
                                                    id={`checkbox-${receive?.id}`}
                                                    checked={receive?.isSelected}
                                                    onChange={() => handleSelect({ value: receive, id: receive?.id })}
                                                    className="custom-checkbox"
                                                />
                                                <label htmlFor={`checkbox-${receive?.id}`} className="custom-checkbox-label">
                                                    {receive?.isSelected && <FaCheck className="check-icon" />} {/* Show icon if selected */}
                                                </label>
                                            </div>
                                        </td>
                                        <td>
                                            {receive?.deliveryName === "OF_POINT" ? (
                                                <>
                                                    {settingByShopId_DATA?.settingByShopId?.deliveryOfPoint ? (
                                                        <div className="d-flex align-items-center">
                                                            <div>
                                                                <p className="fw-bold mb-1" style={{ fontSize: '0.95rem' }}>
                                                                    ຮັບເຄື່ອງຫນ້າຮ້ານ: ({settingByShopId_DATA?.settingByShopId?.shop?.name}-{settingByShopId_DATA?.settingByShopId?.phone})
                                                                </p>
                                                                <small className="text-muted">ຂໍ້ມູນສ່ວນໂຕ:{receive?.userName}-{receive?.userTel}</small>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </>
                                            )
                                                : (
                                                    <div className="d-flex align-items-center">
                                                        <div className="me-3">
                                                            <img
                                                                src={receive?.img ? receive?.img : null}
                                                                style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover' }}
                                                                alt={receive?.deliveryName}
                                                                className="rounded-circle"
                                                            />
                                                        </div>
                                                        <div>
                                                            <p className="fw-bold mb-1" style={{ fontSize: '0.95rem' }}>
                                                                {receive?.deliveryName}: {receive?.userName}-{receive?.userTel}-{newAddress(receive)}
                                                            </p>
                                                            {/* <p className="fw-bold mb-1" style={{ fontSize: '0.95rem' }}>
                                                {receive?.deliveryName}: {receive?.userName}-{receive?.userTel}-{receive?.deliveryName === MIXAY_KEY? receive?.village-receive?.district-receive?.province :
                                                receive?.address || "Name not found..."}
                                            </p> */}
                                                            <small className="text-muted">{receive?.additionalInfo}</small> {/* Optional: Extra details */}
                                                        </div>
                                                    </div>
                                                )}
                                        </td>
                                        <td style={{ width: '10%', textAlign: 'center', verticalAlign: 'middle' }}>
                                            {receive?.deliveryName === "OF_POINT" ? (
                                                <>
                                                    {settingByShopId_DATA?.settingByShopId?.deliveryOfPoint ? (
                                                        // button click to open link
                                                        <a href={settingByShopId_DATA?.settingByShopId?.latLong} target="google_map" className="btn btn-sm btn-primary">
                                                            <FaLink className="me-2" />
                                                        </a>
                                                        // <Button 
                                                        //     variant="danger" 
                                                        //     size="sm" 
                                                        //     onClick={() => handleDelete({value: receive})}
                                                        //     className="shadow-sm"
                                                        // >
                                                        //     <FaTimes />
                                                        // </Button>
                                                    ) : null}
                                                </>
                                            ) : (
                                                <>
                                                {/*// Delete Btn*/}
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={() => handleDelete({ value: receive })}
                                                        className="shadow-sm"
                                                    >
                                                        <FaTimes />
                                                    </Button>
                                                {/*// Update Btn*/}
                                                    <Button
                                                        variant="primary"
                                                        size="sm"
                                                        onClick={() => handleEdit({ value: receive })}
                                                        className="shadow-sm"
                                                        style={{marginTop: 5}}
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                )
                            }
                        </>
                    ))}
                </tbody>
            </Table>

            <p>- ທ່ານສາມາດເພີ່ມທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ໂດຍຄີກທີ່ປຸ່ມ "ສ້າງໃໝ່" </p>
            {/* <p>- ທ່ານສາມາດແກ້ໄຂ້ທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ໂດຍຄີກທີ່ເຄື່ອງຫມາຍ 🖌 </p> */}
            <p>- ທ່ານສາມາດລົບທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ໂດຍຄີກທີ່ເຄື່ອງຫມາຍ ❌ </p>
            {/* <p>- ທ່ານສາມາດຕັ້ງຄ່າເລີ່ມຕົ້ນທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ໂດຍຄີກທີ່ເຄື່ອງຫມາຍ 🔦 </p> */}
            <p>* ຫມາຍເຫດ: ຫລັງຈາກສ້າງທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ທ່ານສາມາດເລືອກທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ໂດຍຄີກທີ່ປຸ່ມ "ຢືນຢັນ" </p>


            {/* //TODO Confirm Button */}
            <div className="d-flex gap-3">
                <Button
                    onClick={() => setIsAddModal(true)}
                    variant="success"
                >
                   ສ້າງໃໝ່
                </Button>
                <Button
                    onClick={() => onClose()}
                    variant="info"
                >
                    ຢືນຢັນ
                </Button>
            </div>

            <Modal centered show={isAddModal} 
                // onHide={onCloseModalAdd} 
                size='lg' >
                <Modal.Header>
                    <Modal.Title>{editData?.id ? "ແກ້ໄຂ້ການຈັດສົ່ງ": "ເພີ່ມທີ່ຢູ່ສຳລັບການຈັດສົ່ງ"}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pb-5">
                    <FormReceiveAddress
                        userConfirm={userConfirm} psid={psid} onCloseModalAdd={onCloseModalAdd} fetchUserAddressData={fetchUserAddressUserId_API} orderData={orderGroup}
                        editData={editData} setEditData={setEditData}
                    />
                </Modal.Body>
            </Modal>


            {/* //TODO Delete Modal */}
            <Modal centered show={isDeleteReceiveModal}
                className="bg-danger"
            >
                <Modal.Header>
                    <Modal.Title>ລົບທີ່ຢູ່ສຳລັບການຈັດສົ່ງ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DeleteReceiveAddress
                        userAddress={isDeleteReceiveData} onClose={onCloseDeleteReceiveModal} setDeleteReceiveModal={setIsDeleteReceiveModal}
                    />
                </Modal.Body>
            </Modal>

            {/* //TODO Update Modal */}
            {/* <Modal centered show={isUpdateReceiveModal}
            className="info"
            onHide={() => {setIsUpdateReceiveModal(false)}}
        >
            <Modal.Header>
                <Modal.Title>ແກ້ໄຂ້ທີ່ຢູ່ສຳລັບການຈັດສົ່ງ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <UpdateReceiveAddress 
                    userAddress={isUpdateReceiveData} onClose={onCloseUpdateReceiveModal} setUpdateReceiveModal={setIsUpdateReceiveModal}
                />
            </Modal.Body> 
        </Modal> */}

        </div>
    );
};

export default ListReceiveAddress;